import { PageTemplate } from '../../../types/pageBuilder';
import { newTemplates } from './newTemplates';

// Template HTML completos e profissionais
export const templates: PageTemplate[] = [
  {
    id: 'saas-modern',
    name: 'SaaS Moderno',
    description: 'Landing page moderna para produtos SaaS e startups de tecnologia',
    thumbnail: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
    category: 'saas',
    gjsHtml: `
<style>
  .saas-hero-title { font-size: clamp(2rem, 5vw, 4rem); }
  .saas-section-title { font-size: clamp(1.75rem, 4vw, 3rem); }
  .saas-price { font-size: clamp(2.5rem, 6vw, 4rem); }
  .saas-btn { padding: 16px 32px; font-size: 1rem; }
  @media (max-width: 768px) {
    .saas-hero { padding: 60px 16px !important; }
    .saas-section { padding: 60px 16px !important; }
    .saas-features-grid { grid-template-columns: 1fr !important; }
    .saas-testimonials-grid { grid-template-columns: 1fr !important; }
    .saas-pricing-grid { grid-template-columns: 1fr !important; max-width: 400px !important; margin: 0 auto !important; }
    .saas-pricing-popular { transform: none !important; }
    .saas-footer-grid { flex-direction: column !important; gap: 32px !important; text-align: center !important; }
    .saas-footer-links { justify-content: center !important; }
    .saas-logos { gap: 32px !important; }
    .saas-logo { font-size: 18px !important; }
  }
</style>

<!-- HERO -->
<section class="saas-hero" style="background: linear-gradient(135deg, #0f0f23 0%, #1a1a3e 50%, #2d1b4e 100%); padding: 100px 20px; position: relative; overflow: hidden;">
  <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(168, 85, 247, 0.15) 0%, transparent 50%);"></div>
  <div style="max-width: 1200px; margin: 0 auto; position: relative; z-index: 1;">
    <div style="text-align: center; max-width: 800px; margin: 0 auto;">
      <span style="display: inline-block; padding: 8px 20px; background: rgba(168, 85, 247, 0.2); border: 1px solid rgba(168, 85, 247, 0.3); border-radius: 50px; color: #c4b5fd; font-size: 14px; font-weight: 500; margin-bottom: 24px;">
        ✨ Novo: Integração com IA disponível
      </span>
      <h1 class="saas-hero-title" style="font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.1;">
        Automatize seu negócio com <span style="background: linear-gradient(90deg, #a78bfa, #f472b6); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">inteligência</span>
      </h1>
      <p style="font-size: clamp(1rem, 2.5vw, 1.25rem); color: #a1a1aa; margin-bottom: 40px; line-height: 1.7;">
        A plataforma completa que une automação, analytics e IA para escalar seu negócio. Mais de 10.000 empresas já confiam em nós.
      </p>
      <div style="display: flex; gap: 16px; justify-content: center; flex-wrap: wrap;">
        <a href="#" class="saas-btn" style="display: inline-flex; align-items: center; gap: 8px; background: linear-gradient(135deg, #a855f7, #ec4899); color: white; font-weight: 700; border-radius: 12px; text-decoration: none; box-shadow: 0 20px 40px rgba(168, 85, 247, 0.3); transition: transform 0.2s;">
          Começar Grátis →
        </a>
        <a href="#" class="saas-btn" style="display: inline-flex; align-items: center; gap: 8px; background: rgba(255,255,255,0.1); color: white; font-weight: 600; border: 1px solid rgba(255,255,255,0.2); border-radius: 12px; text-decoration: none;">
          Ver Demo
        </a>
      </div>
      <p style="margin-top: 24px; color: #71717a; font-size: 14px;">
        ✓ 7 dias grátis · ✓ Sem cartão de crédito · ✓ Cancele quando quiser
      </p>
    </div>
  </div>
</section>

<!-- LOGOS -->
<section style="padding: 60px 20px; background: #fafafa; border-bottom: 1px solid #e5e5e5;">
  <div style="max-width: 1200px; margin: 0 auto; text-align: center;">
    <p style="color: #71717a; font-size: 14px; text-transform: uppercase; letter-spacing: 2px; margin-bottom: 32px;">Empresas que confiam em nós</p>
    <div class="saas-logos" style="display: flex; justify-content: center; align-items: center; gap: 60px; flex-wrap: wrap; opacity: 0.5;">
      <span class="saas-logo" style="font-size: 24px; font-weight: 700; color: #374151;">Google</span>
      <span class="saas-logo" style="font-size: 24px; font-weight: 700; color: #374151;">Microsoft</span>
      <span class="saas-logo" style="font-size: 24px; font-weight: 700; color: #374151;">Spotify</span>
      <span class="saas-logo" style="font-size: 24px; font-weight: 700; color: #374151;">Slack</span>
      <span class="saas-logo" style="font-size: 24px; font-weight: 700; color: #374151;">Notion</span>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="saas-section" style="padding: 100px 20px; background: white;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div style="text-align: center; margin-bottom: 60px;">
      <span style="color: #a855f7; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px;">Recursos</span>
      <h2 class="saas-section-title" style="font-weight: 800; color: #111827; margin-top: 12px;">Tudo que você precisa para crescer</h2>
      <p style="font-size: clamp(1rem, 2vw, 1.25rem); color: #6b7280; margin-top: 16px; max-width: 600px; margin-left: auto; margin-right: auto;">Ferramentas poderosas para automatizar, analisar e escalar seu negócio</p>
    </div>
    <div class="saas-features-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 32px;">
      <div style="padding: 40px; background: linear-gradient(145deg, #faf5ff 0%, #ffffff 100%); border-radius: 24px; border: 1px solid #e9d5ff;">
        <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #a855f7, #7c3aed); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px; font-size: 28px;">⚡</div>
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #111827; margin-bottom: 12px;">Automação Inteligente</h3>
        <p style="color: #6b7280; line-height: 1.7;">Automatize tarefas repetitivas e economize horas de trabalho toda semana com nossa IA.</p>
      </div>
      <div style="padding: 40px; background: linear-gradient(145deg, #fdf2f8 0%, #ffffff 100%); border-radius: 24px; border: 1px solid #fbcfe8;">
        <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #ec4899, #db2777); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px; font-size: 28px;">📊</div>
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #111827; margin-bottom: 12px;">Analytics Avançado</h3>
        <p style="color: #6b7280; line-height: 1.7;">Dashboards em tempo real com insights acionáveis para tomar decisões melhores.</p>
      </div>
      <div style="padding: 40px; background: linear-gradient(145deg, #eff6ff 0%, #ffffff 100%); border-radius: 24px; border: 1px solid #bfdbfe;">
        <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #3b82f6, #1d4ed8); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px; font-size: 28px;">🔗</div>
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #111827; margin-bottom: 12px;">+100 Integrações</h3>
        <p style="color: #6b7280; line-height: 1.7;">Conecte todas suas ferramentas favoritas em um só lugar, sem código.</p>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="saas-section" style="padding: 100px 20px; background: #f9fafb;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div style="text-align: center; margin-bottom: 60px;">
      <span style="color: #a855f7; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px;">Depoimentos</span>
      <h2 class="saas-section-title" style="font-weight: 800; color: #111827; margin-top: 12px;">O que nossos clientes dizem</h2>
    </div>
    <div class="saas-testimonials-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 32px;">
      <div style="padding: 32px; background: white; border-radius: 24px; box-shadow: 0 4px 20px rgba(0,0,0,0.08);">
        <div style="color: #fbbf24; font-size: 20px; margin-bottom: 16px;">★★★★★</div>
        <p style="color: #374151; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px;">"Triplicamos nossa produtividade em 3 meses. A automação é simplesmente incrível!"</p>
        <div style="display: flex; align-items: center; gap: 16px;">
          <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=60&h=60&fit=crop" style="width: 56px; height: 56px; border-radius: 50%; object-fit: cover;" alt="Avatar"/>
          <div>
            <p style="font-weight: 700; color: #111827; margin: 0;">Maria Silva</p>
            <p style="color: #6b7280; font-size: 14px; margin: 4px 0 0 0;">CEO, TechStartup</p>
          </div>
        </div>
      </div>
      <div style="padding: 32px; background: white; border-radius: 24px; box-shadow: 0 4px 20px rgba(0,0,0,0.08);">
        <div style="color: #fbbf24; font-size: 20px; margin-bottom: 16px;">★★★★★</div>
        <p style="color: #374151; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px;">"O melhor investimento que fiz para minha empresa. ROI em menos de 30 dias."</p>
        <div style="display: flex; align-items: center; gap: 16px;">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop" style="width: 56px; height: 56px; border-radius: 50%; object-fit: cover;" alt="Avatar"/>
          <div>
            <p style="font-weight: 700; color: #111827; margin: 0;">Pedro Santos</p>
            <p style="color: #6b7280; font-size: 14px; margin: 4px 0 0 0;">Fundador, E-commerce Plus</p>
          </div>
        </div>
      </div>
      <div style="padding: 32px; background: white; border-radius: 24px; box-shadow: 0 4px 20px rgba(0,0,0,0.08);">
        <div style="color: #fbbf24; font-size: 20px; margin-bottom: 16px;">★★★★★</div>
        <p style="color: #374151; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px;">"Finalmente uma plataforma que entrega o que promete. Suporte excepcional!"</p>
        <div style="display: flex; align-items: center; gap: 16px;">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=60&h=60&fit=crop" style="width: 56px; height: 56px; border-radius: 50%; object-fit: cover;" alt="Avatar"/>
          <div>
            <p style="font-weight: 700; color: #111827; margin: 0;">Ana Costa</p>
            <p style="color: #6b7280; font-size: 14px; margin: 4px 0 0 0;">Marketing Manager</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- PRICING -->
<section class="saas-section" style="padding: 100px 20px; background: white;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div style="text-align: center; margin-bottom: 60px;">
      <span style="color: #a855f7; font-weight: 600; font-size: 14px; text-transform: uppercase; letter-spacing: 1px;">Preços</span>
      <h2 class="saas-section-title" style="font-weight: 800; color: #111827; margin-top: 12px;">Planos para todos os tamanhos</h2>
    </div>
    <div class="saas-pricing-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 32px; max-width: 1000px; margin: 0 auto;">
      <div style="padding: 40px; background: white; border-radius: 24px; border: 2px solid #e5e7eb;">
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #111827;">Starter</h3>
        <p style="color: #6b7280; margin-top: 8px;">Para quem está começando</p>
        <div style="margin: 32px 0;">
          <span class="saas-price" style="font-weight: 800; color: #111827;">R$0</span>
          <span style="color: #6b7280;">/mês</span>
        </div>
        <ul style="list-style: none; padding: 0; margin: 0 0 32px 0;">
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #374151;">✓ Até 1.000 contatos</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #374151;">✓ 1 automação</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #374151;">✓ Suporte por email</li>
        </ul>
        <a href="#" style="display: block; text-align: center; padding: 16px; background: #f3f4f6; color: #374151; font-weight: 600; border-radius: 12px; text-decoration: none;">Começar Grátis</a>
      </div>
      <div class="saas-pricing-popular" style="padding: 40px; background: linear-gradient(135deg, #a855f7, #7c3aed); border-radius: 24px; transform: scale(1.05); position: relative;">
        <span style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); padding: 6px 20px; background: linear-gradient(135deg, #f97316, #ea580c); color: white; font-size: 12px; font-weight: 700; border-radius: 50px;">MAIS POPULAR</span>
        <h3 style="font-size: 1.5rem; font-weight: 700; color: white;">Pro</h3>
        <p style="color: rgba(255,255,255,0.8); margin-top: 8px;">Para negócios em crescimento</p>
        <div style="margin: 32px 0;">
          <span class="saas-price" style="font-weight: 800; color: white;">R$97</span>
          <span style="color: rgba(255,255,255,0.8);">/mês</span>
        </div>
        <ul style="list-style: none; padding: 0; margin: 0 0 32px 0;">
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: white;">✓ Contatos ilimitados</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: white;">✓ Automações ilimitadas</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: white;">✓ Integrações premium</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: white;">✓ Suporte prioritário 24/7</li>
        </ul>
        <a href="#" style="display: block; text-align: center; padding: 16px; background: white; color: #7c3aed; font-weight: 700; border-radius: 12px; text-decoration: none;">Assinar Pro</a>
      </div>
      <div style="padding: 40px; background: white; border-radius: 24px; border: 2px solid #e5e7eb;">
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #111827;">Enterprise</h3>
        <p style="color: #6b7280; margin-top: 8px;">Para grandes empresas</p>
        <div style="margin: 32px 0;">
          <span class="saas-price" style="font-weight: 800; color: #111827;">Custom</span>
        </div>
        <ul style="list-style: none; padding: 0; margin: 0 0 32px 0;">
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #374151;">✓ Tudo do Pro</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #374151;">✓ SLA garantido</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #374151;">✓ Manager dedicado</li>
          <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #374151;">✓ API personalizada</li>
        </ul>
        <a href="#" style="display: block; text-align: center; padding: 16px; background: #f3f4f6; color: #374151; font-weight: 600; border-radius: 12px; text-decoration: none;">Falar com Vendas</a>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="saas-section" style="padding: 100px 20px; background: linear-gradient(135deg, #a855f7 0%, #7c3aed 50%, #6366f1 100%);">
  <div style="max-width: 800px; margin: 0 auto; text-align: center;">
    <h2 class="saas-section-title" style="font-weight: 800; color: white; margin-bottom: 20px;">Pronto para começar?</h2>
    <p style="font-size: clamp(1rem, 2vw, 1.25rem); color: rgba(255,255,255,0.9); margin-bottom: 40px;">Junte-se a milhares de empresas que já transformaram seus negócios.</p>
    <a href="#" class="saas-btn" style="display: inline-block; background: white; color: #7c3aed; font-weight: 700; border-radius: 12px; text-decoration: none; box-shadow: 0 20px 40px rgba(0,0,0,0.2);">
      Criar Conta Grátis →
    </a>
    <p style="margin-top: 24px; color: rgba(255,255,255,0.7); font-size: 14px;">Sem cartão de crédito · Setup em 2 minutos</p>
  </div>
</section>

<!-- FOOTER -->
<footer style="padding: 60px 20px 80px; background: #0f0f23;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div style="display: flex; flex-wrap: wrap; justify-content: space-between; gap: 40px; margin-bottom: 40px;">
      <div>
        <div style="font-size: 1.5rem; font-weight: 800; color: white; margin-bottom: 16px;">SuaMarca</div>
        <p style="color: #71717a; max-width: 300px;">A plataforma de automação mais completa para escalar seu negócio.</p>
      </div>
      <div style="display: flex; gap: 60px; flex-wrap: wrap;">
        <div>
          <h4 style="color: white; font-weight: 600; margin-bottom: 16px;">Produto</h4>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Recursos</a>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Preços</a>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Integrações</a>
        </div>
        <div>
          <h4 style="color: white; font-weight: 600; margin-bottom: 16px;">Empresa</h4>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Sobre</a>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Blog</a>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Carreiras</a>
        </div>
        <div>
          <h4 style="color: white; font-weight: 600; margin-bottom: 16px;">Suporte</h4>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Central de Ajuda</a>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Contato</a>
          <a href="#" style="display: block; color: #71717a; text-decoration: none; padding: 8px 0;">Status</a>
        </div>
      </div>
    </div>
    <div style="border-top: 1px solid #27272a; padding-top: 30px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 20px;">
      <p style="color: #52525b; font-size: 14px; margin: 0;">© 2025 SuaMarca. Todos os direitos reservados.</p>
      <div style="display: flex; gap: 24px;">
        <a href="#" style="color: #71717a; text-decoration: none; font-size: 14px;">Termos</a>
        <a href="#" style="color: #71717a; text-decoration: none; font-size: 14px;">Privacidade</a>
      </div>
    </div>
  </div>
</footer>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'lead-capture',
    name: 'Captura de Leads',
    description: 'Página otimizada para capturar leads com ebook ou material rico',
    thumbnail: 'https://images.unsplash.com/photo-1434626881859-194d67b2b86f?w=400&h=300&fit=crop',
    category: 'lead-magnet',
    gjsHtml: `
<!-- HERO LEAD CAPTURE -->
<section style="background: linear-gradient(135deg, #059669 0%, #047857 50%, #065f46 100%); padding: 80px 20px; min-height: 100vh; display: flex; align-items: center;">
  <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center;">
    <div>
      <span style="display: inline-block; padding: 8px 16px; background: rgba(255,255,255,0.2); border-radius: 50px; color: #d1fae5; font-size: 14px; font-weight: 500; margin-bottom: 24px;">
        📚 E-book Gratuito
      </span>
      <h1 style="font-size: 3.5rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.1;">
        Guia Completo: Como Dobrar Suas Vendas em 90 Dias
      </h1>
      <p style="font-size: 1.25rem; color: #a7f3d0; margin-bottom: 32px; line-height: 1.7;">
        Descubra as estratégias que os top performers usam para escalar resultados de forma previsível.
      </p>
      <ul style="list-style: none; padding: 0; margin: 0 0 40px 0;">
        <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: white; font-size: 1.1rem;">
          <span style="background: #10b981; padding: 4px; border-radius: 50%;">✓</span>
          47 estratégias comprovadas
        </li>
        <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: white; font-size: 1.1rem;">
          <span style="background: #10b981; padding: 4px; border-radius: 50%;">✓</span>
          Planilhas e templates prontos
        </li>
        <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; color: white; font-size: 1.1rem;">
          <span style="background: #10b981; padding: 4px; border-radius: 50%;">✓</span>
          Casos de sucesso reais
        </li>
      </ul>
    </div>
    <div style="background: white; padding: 48px; border-radius: 24px; box-shadow: 0 25px 50px rgba(0,0,0,0.2);">
      <h2 style="font-size: 1.75rem; font-weight: 700; color: #111827; margin-bottom: 8px; text-align: center;">Baixe Grátis Agora</h2>
      <p style="color: #6b7280; text-align: center; margin-bottom: 32px;">Preencha abaixo para receber o e-book</p>
      <form data-success-message="E-book enviado para seu e-mail!">
        <div style="margin-bottom: 20px;">
          <input type="text" name="name" placeholder="Seu nome completo" required style="width: 100%; padding: 16px 20px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1rem; outline: none; box-sizing: border-box;"/>
        </div>
        <div style="margin-bottom: 20px;">
          <input type="email" name="email" placeholder="Seu melhor e-mail" required style="width: 100%; padding: 16px 20px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1rem; outline: none; box-sizing: border-box;"/>
        </div>
        <div style="margin-bottom: 20px;">
          <input type="tel" name="phone" placeholder="WhatsApp (opcional)" style="width: 100%; padding: 16px 20px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1rem; outline: none; box-sizing: border-box;"/>
        </div>
        <button type="submit" style="width: 100%; padding: 18px; background: linear-gradient(135deg, #059669, #047857); color: white; font-weight: 700; font-size: 1.1rem; border: none; border-radius: 12px; cursor: pointer;">
          QUERO MEU E-BOOK GRÁTIS →
        </button>
      </form>
      <p style="text-align: center; color: #9ca3af; font-size: 13px; margin-top: 20px;">
        🔒 Seus dados estão seguros. Não enviamos spam.
      </p>
    </div>
  </div>
</section>

<!-- SOCIAL PROOF -->
<section style="padding: 60px 20px; background: #f9fafb;">
  <div style="max-width: 1000px; margin: 0 auto; text-align: center;">
    <p style="color: #6b7280; font-size: 1.1rem; margin-bottom: 32px;">Mais de <strong style="color: #059669;">15.000 downloads</strong> e avaliação 4.9/5</p>
    <div style="display: flex; justify-content: center; gap: 40px; flex-wrap: wrap;">
      <div style="display: flex; align-items: center; gap: 16px;">
        <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop" style="width: 50px; height: 50px; border-radius: 50%;" alt=""/>
        <div style="text-align: left;">
          <p style="color: #fbbf24; margin: 0;">★★★★★</p>
          <p style="color: #374151; font-size: 14px; margin: 4px 0 0 0;">"Mudou minha perspectiva"</p>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 16px;">
        <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50&h=50&fit=crop" style="width: 50px; height: 50px; border-radius: 50%;" alt=""/>
        <div style="text-align: left;">
          <p style="color: #fbbf24; margin: 0;">★★★★★</p>
          <p style="color: #374151; font-size: 14px; margin: 4px 0 0 0;">"Conteúdo de altíssima qualidade"</p>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 16px;">
        <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop" style="width: 50px; height: 50px; border-radius: 50%;" alt=""/>
        <div style="text-align: left;">
          <p style="color: #fbbf24; margin: 0;">★★★★★</p>
          <p style="color: #374151; font-size: 14px; margin: 4px 0 0 0;">"Implementei e vi resultados"</p>
        </div>
      </div>
    </div>
  </div>
</section>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'webinar-registration',
    name: 'Webinar/Evento',
    description: 'Página de inscrição para webinars e eventos online',
    thumbnail: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=400&h=300&fit=crop',
    category: 'webinar',
    gjsHtml: `
<!-- WEBINAR HERO -->
<section style="background: linear-gradient(180deg, #1e1b4b 0%, #312e81 100%); padding: 80px 20px; min-height: 100vh;">
  <div style="max-width: 1000px; margin: 0 auto; text-align: center;">
    <span style="display: inline-block; padding: 10px 24px; background: linear-gradient(135deg, #ef4444, #dc2626); border-radius: 50px; color: white; font-size: 14px; font-weight: 700; margin-bottom: 24px; animation: pulse 2s infinite;">
      🔴 AO VIVO - Vagas Limitadas
    </span>
    <h1 style="font-size: 3.5rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.1;">
      Masterclass Gratuita:<br/>
      <span style="background: linear-gradient(90deg, #f472b6, #c084fc); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">Como Escalar para 7 Dígitos</span>
    </h1>
    <p style="font-size: 1.25rem; color: #c7d2fe; margin-bottom: 40px; max-width: 700px; margin-left: auto; margin-right: auto;">
      Descubra o método exato que usei para sair de R$0 para R$1M em faturamento em apenas 18 meses.
    </p>

    <div style="background: rgba(255,255,255,0.1); backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.2); border-radius: 24px; padding: 48px; max-width: 500px; margin: 0 auto 40px;">
      <div style="display: flex; justify-content: center; gap: 24px; margin-bottom: 32px;">
        <div style="text-align: center;">
          <div style="font-size: 3rem; font-weight: 800; color: white;">15</div>
          <div style="color: #a5b4fc; font-size: 14px;">Dias</div>
        </div>
        <div style="font-size: 3rem; font-weight: 800; color: white;">:</div>
        <div style="text-align: center;">
          <div style="font-size: 3rem; font-weight: 800; color: white;">08</div>
          <div style="color: #a5b4fc; font-size: 14px;">Horas</div>
        </div>
        <div style="font-size: 3rem; font-weight: 800; color: white;">:</div>
        <div style="text-align: center;">
          <div style="font-size: 3rem; font-weight: 800; color: white;">45</div>
          <div style="color: #a5b4fc; font-size: 14px;">Min</div>
        </div>
      </div>
      <form data-success-message="Inscricao confirmada! Verifique seu e-mail para os detalhes.">
        <input type="text" name="name" placeholder="Seu nome" required style="width: 100%; padding: 16px 20px; border: none; border-radius: 12px; font-size: 1rem; margin-bottom: 16px; box-sizing: border-box;"/>
        <input type="email" name="email" placeholder="Seu melhor e-mail" required style="width: 100%; padding: 16px 20px; border: none; border-radius: 12px; font-size: 1rem; margin-bottom: 16px; box-sizing: border-box;"/>
        <button type="submit" style="width: 100%; padding: 18px; background: linear-gradient(135deg, #f472b6, #c084fc); color: white; font-weight: 700; font-size: 1.1rem; border: none; border-radius: 12px; cursor: pointer;">
          GARANTIR MINHA VAGA GRÁTIS
        </button>
      </form>
      <p style="color: #a5b4fc; font-size: 13px; margin-top: 16px;">Restam apenas 127 vagas</p>
    </div>

    <div style="display: flex; justify-content: center; gap: 16px; flex-wrap: wrap;">
      <div style="display: flex; align-items: center; gap: 8px; color: #c7d2fe;">
        <span>📅</span> 20 de Janeiro, 20h
      </div>
      <div style="display: flex; align-items: center; gap: 8px; color: #c7d2fe;">
        <span>⏱️</span> 2 horas de conteúdo
      </div>
      <div style="display: flex; align-items: center; gap: 8px; color: #c7d2fe;">
        <span>🎁</span> Bônus exclusivos
      </div>
    </div>
  </div>
</section>

<!-- SPEAKER -->
<section style="padding: 80px 20px; background: white;">
  <div style="max-width: 900px; margin: 0 auto; display: grid; grid-template-columns: 300px 1fr; gap: 60px; align-items: center;">
    <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=400&fit=crop" style="width: 100%; border-radius: 20px; box-shadow: 0 20px 40px rgba(0,0,0,0.1);" alt="Speaker"/>
    <div>
      <span style="color: #6366f1; font-weight: 600; font-size: 14px; text-transform: uppercase;">Seu Mentor</span>
      <h2 style="font-size: 2.5rem; font-weight: 800; color: #111827; margin: 12px 0;">João Silva</h2>
      <p style="color: #6b7280; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px;">
        Empreendedor serial com mais de 15 anos de experiência. Fundador de 3 startups de sucesso e mentor de mais de 500 empreendedores.
      </p>
      <div style="display: flex; gap: 32px;">
        <div>
          <div style="font-size: 2rem; font-weight: 800; color: #6366f1;">R$50M+</div>
          <div style="color: #6b7280; font-size: 14px;">em vendas geradas</div>
        </div>
        <div>
          <div style="font-size: 2rem; font-weight: 800; color: #6366f1;">500+</div>
          <div style="color: #6b7280; font-size: 14px;">alunos mentorados</div>
        </div>
      </div>
    </div>
  </div>
</section>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'product-launch',
    name: 'Lançamento de Produto',
    description: 'Página de lançamento com countdown e urgência',
    thumbnail: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop',
    category: 'product-launch',
    gjsHtml: `
<!-- LAUNCH HERO -->
<section style="background: #000000; padding: 100px 20px; min-height: 100vh; display: flex; align-items: center; position: relative; overflow: hidden;">
  <div style="position: absolute; inset: 0; background: radial-gradient(ellipse at center, rgba(251,191,36,0.15) 0%, transparent 70%);"></div>
  <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; position: relative;">
    <div>
      <span style="display: inline-block; padding: 8px 20px; background: linear-gradient(135deg, #fbbf24, #f59e0b); border-radius: 50px; color: #000; font-size: 14px; font-weight: 700; margin-bottom: 24px;">
        ⭐ LANÇAMENTO EXCLUSIVO
      </span>
      <h1 style="font-size: 4rem; font-weight: 900; color: white; margin-bottom: 24px; line-height: 1;">
        O Produto Que Vai<br/>
        <span style="background: linear-gradient(90deg, #fbbf24, #f59e0b); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">Revolucionar</span><br/>
        Seu Mercado
      </h1>
      <p style="font-size: 1.25rem; color: #9ca3af; margin-bottom: 40px; line-height: 1.7;">
        Prepare-se para conhecer a inovação que todos estavam esperando. Seja um dos primeiros a ter acesso.
      </p>
      <div style="display: flex; gap: 16px; flex-wrap: wrap;">
        <a href="#" style="display: inline-block; padding: 20px 40px; background: linear-gradient(135deg, #fbbf24, #f59e0b); color: #000; font-weight: 800; font-size: 1.1rem; border-radius: 12px; text-decoration: none;">
          QUERO SER AVISADO
        </a>
        <a href="#" style="display: inline-block; padding: 20px 40px; border: 2px solid #fbbf24; color: #fbbf24; font-weight: 600; font-size: 1.1rem; border-radius: 12px; text-decoration: none;">
          Ver Teaser
        </a>
      </div>
    </div>
    <div style="position: relative;">
      <div style="position: absolute; inset: -20px; background: linear-gradient(135deg, #fbbf24, #f59e0b); border-radius: 32px; filter: blur(40px); opacity: 0.3;"></div>
      <img src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&h=500&fit=crop" style="width: 100%; border-radius: 24px; position: relative;" alt="Product"/>
    </div>
  </div>
</section>

<!-- COUNTDOWN -->
<section style="padding: 60px 20px; background: #111111;">
  <div style="max-width: 800px; margin: 0 auto; text-align: center;">
    <h2 style="font-size: 1.5rem; color: white; margin-bottom: 32px;">Lançamento em:</h2>
    <div style="display: flex; justify-content: center; gap: 24px;">
      <div style="padding: 24px 32px; background: #1f1f1f; border-radius: 16px; border: 1px solid #333;">
        <div style="font-size: 3.5rem; font-weight: 900; color: #fbbf24;">07</div>
        <div style="color: #6b7280; font-size: 14px; text-transform: uppercase;">Dias</div>
      </div>
      <div style="padding: 24px 32px; background: #1f1f1f; border-radius: 16px; border: 1px solid #333;">
        <div style="font-size: 3.5rem; font-weight: 900; color: #fbbf24;">12</div>
        <div style="color: #6b7280; font-size: 14px; text-transform: uppercase;">Horas</div>
      </div>
      <div style="padding: 24px 32px; background: #1f1f1f; border-radius: 16px; border: 1px solid #333;">
        <div style="font-size: 3.5rem; font-weight: 900; color: #fbbf24;">45</div>
        <div style="color: #6b7280; font-size: 14px; text-transform: uppercase;">Min</div>
      </div>
      <div style="padding: 24px 32px; background: #1f1f1f; border-radius: 16px; border: 1px solid #333;">
        <div style="font-size: 3.5rem; font-weight: 900; color: #fbbf24;">30</div>
        <div style="color: #6b7280; font-size: 14px; text-transform: uppercase;">Seg</div>
      </div>
    </div>
  </div>
</section>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'agency-services',
    name: 'Agência Digital',
    description: 'Apresente seus serviços de agência de forma profissional',
    thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<style>
  * { box-sizing: border-box; }
  .agency-title { font-size: clamp(2.5rem, 6vw, 4.5rem); }
  .agency-section-title { font-size: clamp(2rem, 4vw, 3rem); }
  .agency-text { font-size: clamp(1rem, 1.5vw, 1.25rem); }
  @media (max-width: 1024px) {
    .agency-hero-grid { grid-template-columns: 1fr !important; }
    .agency-hero-visual { display: none !important; }
    .agency-work-grid { grid-template-columns: 1fr 1fr !important; }
  }
  @media (max-width: 768px) {
    .agency-hero { padding: 80px 20px !important; }
    .agency-section { padding: 80px 20px !important; }
    .agency-nav { padding: 16px 20px !important; }
    .agency-nav-links { display: none !important; }
    .agency-services-grid { grid-template-columns: 1fr !important; }
    .agency-work-grid { grid-template-columns: 1fr !important; }
    .agency-stats-grid { grid-template-columns: 1fr 1fr !important; }
    .agency-cta-content { flex-direction: column !important; text-align: center !important; }
    .agency-footer-grid { grid-template-columns: 1fr !important; text-align: center !important; }
    .agency-footer-links { justify-content: center !important; }
  }
  @media (max-width: 480px) {
    .agency-stats-grid { grid-template-columns: 1fr !important; }
    .agency-buttons { flex-direction: column !important; width: 100% !important; }
    .agency-btn { width: 100% !important; justify-content: center !important; }
  }
</style>

<!-- NAVIGATION -->
<nav class="agency-nav" style="padding: 20px 40px; background: white; position: sticky; top: 0; z-index: 100; border-bottom: 1px solid #f1f5f9;">
  <div style="max-width: 1400px; margin: 0 auto; display: flex; justify-content: space-between; align-items: center;">
    <div style="font-size: 1.5rem; font-weight: 900; color: #0f172a;">Studio<span style="color: #6366f1;">X</span></div>
    <div class="agency-nav-links" style="display: flex; gap: 40px;">
      <a href="#servicos" style="color: #64748b; text-decoration: none; font-weight: 500; font-size: 0.95rem;">Serviços</a>
      <a href="#trabalhos" style="color: #64748b; text-decoration: none; font-weight: 500; font-size: 0.95rem;">Trabalhos</a>
      <a href="#sobre" style="color: #64748b; text-decoration: none; font-weight: 500; font-size: 0.95rem;">Sobre</a>
      <a href="#contato" style="color: #64748b; text-decoration: none; font-weight: 500; font-size: 0.95rem;">Contato</a>
    </div>
    <a href="#contato" style="padding: 12px 24px; background: #0f172a; color: white; text-decoration: none; border-radius: 8px; font-weight: 600; font-size: 0.9rem;">Fale Conosco</a>
  </div>
</nav>

<!-- HERO -->
<section class="agency-hero" style="padding: 120px 40px; background: #fafbfc;">
  <div class="agency-hero-grid" style="max-width: 1400px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center;">
    <div>
      <div style="display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; background: #f0fdf4; border-radius: 100px; margin-bottom: 32px;">
        <span style="width: 8px; height: 8px; background: #22c55e; border-radius: 50%;"></span>
        <span style="color: #166534; font-size: 0.875rem; font-weight: 500;">Disponível para novos projetos</span>
      </div>
      <h1 class="agency-title" style="color: #0f172a; font-weight: 800; line-height: 1.1; margin: 0 0 24px 0;">
        Criamos experiências digitais que <span style="color: #6366f1;">impactam</span>
      </h1>
      <p class="agency-text" style="color: #64748b; line-height: 1.8; margin-bottom: 40px; max-width: 500px;">
        Somos uma agência de design e tecnologia. Transformamos ideias em produtos digitais que geram resultados reais para nossos clientes.
      </p>
      <div class="agency-buttons" style="display: flex; gap: 16px; flex-wrap: wrap;">
        <a href="#contato" class="agency-btn" style="display: inline-flex; align-items: center; gap: 8px; padding: 18px 32px; background: #0f172a; color: white; text-decoration: none; border-radius: 12px; font-weight: 600;">
          Começar um projeto
          <span>→</span>
        </a>
        <a href="#trabalhos" class="agency-btn" style="display: inline-flex; align-items: center; gap: 8px; padding: 18px 32px; background: white; color: #0f172a; text-decoration: none; border-radius: 12px; font-weight: 600; border: 2px solid #e2e8f0;">
          Ver portfólio
        </a>
      </div>
    </div>
    <div class="agency-hero-visual" style="position: relative;">
      <div style="aspect-ratio: 4/3; background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%); border-radius: 24px; overflow: hidden;">
        <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=450&fit=crop" style="width: 100%; height: 100%; object-fit: cover; mix-blend-mode: overlay; opacity: 0.7;" alt="Team working"/>
      </div>
      <div style="position: absolute; bottom: -20px; left: -20px; padding: 20px 28px; background: white; border-radius: 16px; box-shadow: 0 20px 40px rgba(0,0,0,0.1);">
        <div style="font-size: 2rem; font-weight: 800; color: #0f172a;">150+</div>
        <div style="color: #64748b; font-size: 0.875rem;">Projetos entregues</div>
      </div>
    </div>
  </div>
</section>

<!-- SERVICES -->
<section id="servicos" class="agency-section" style="padding: 120px 40px; background: white;">
  <div style="max-width: 1400px; margin: 0 auto;">
    <div style="max-width: 600px; margin-bottom: 64px;">
      <span style="color: #6366f1; font-weight: 600; font-size: 0.875rem; text-transform: uppercase; letter-spacing: 2px;">Serviços</span>
      <h2 class="agency-section-title" style="color: #0f172a; font-weight: 800; margin: 16px 0 0 0;">Soluções completas para sua marca crescer</h2>
    </div>
    <div class="agency-services-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px;">
      <div style="padding: 40px; background: #f8fafc; border-radius: 20px; transition: all 0.3s;">
        <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 14px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px;">
          <span style="font-size: 24px;">🎨</span>
        </div>
        <h3 style="font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px;">Branding & Identidade</h3>
        <p style="color: #64748b; line-height: 1.7; margin-bottom: 20px;">Criamos marcas memoráveis com identidade visual única que conecta com seu público.</p>
        <a href="#" style="color: #6366f1; font-weight: 600; text-decoration: none; display: inline-flex; align-items: center; gap: 6px;">Saiba mais <span>→</span></a>
      </div>
      <div style="padding: 40px; background: #f8fafc; border-radius: 20px; transition: all 0.3s;">
        <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #ec4899, #f43f5e); border-radius: 14px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px;">
          <span style="font-size: 24px;">💻</span>
        </div>
        <h3 style="font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px;">Web Design & Dev</h3>
        <p style="color: #64748b; line-height: 1.7; margin-bottom: 20px;">Sites e aplicações web de alta performance com foco em conversão e experiência.</p>
        <a href="#" style="color: #6366f1; font-weight: 600; text-decoration: none; display: inline-flex; align-items: center; gap: 6px;">Saiba mais <span>→</span></a>
      </div>
      <div style="padding: 40px; background: #f8fafc; border-radius: 20px; transition: all 0.3s;">
        <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #14b8a6, #22c55e); border-radius: 14px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px;">
          <span style="font-size: 24px;">📈</span>
        </div>
        <h3 style="font-size: 1.25rem; font-weight: 700; color: #0f172a; margin-bottom: 12px;">Marketing Digital</h3>
        <p style="color: #64748b; line-height: 1.7; margin-bottom: 20px;">Estratégias de growth, SEO, mídia paga e conteúdo para escalar seu negócio.</p>
        <a href="#" style="color: #6366f1; font-weight: 600; text-decoration: none; display: inline-flex; align-items: center; gap: 6px;">Saiba mais <span>→</span></a>
      </div>
    </div>
  </div>
</section>

<!-- WORK -->
<section id="trabalhos" class="agency-section" style="padding: 120px 40px; background: #0f172a;">
  <div style="max-width: 1400px; margin: 0 auto;">
    <div style="display: flex; justify-content: space-between; align-items: end; margin-bottom: 64px; flex-wrap: wrap; gap: 24px;">
      <div>
        <span style="color: #6366f1; font-weight: 600; font-size: 0.875rem; text-transform: uppercase; letter-spacing: 2px;">Portfólio</span>
        <h2 class="agency-section-title" style="color: white; font-weight: 800; margin: 16px 0 0 0;">Trabalhos selecionados</h2>
      </div>
      <a href="#" style="color: #94a3b8; text-decoration: none; font-weight: 500; display: flex; align-items: center; gap: 8px;">Ver todos os projetos <span>→</span></a>
    </div>
    <div class="agency-work-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px;">
      <div style="aspect-ratio: 4/5; border-radius: 20px; overflow: hidden; position: relative; background: #1e293b;">
        <img src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=400&h=500&fit=crop" style="width: 100%; height: 100%; object-fit: cover; opacity: 0.9;" alt="Project 1"/>
        <div style="position: absolute; bottom: 0; left: 0; right: 0; padding: 32px; background: linear-gradient(transparent, rgba(0,0,0,0.8));">
          <p style="color: #94a3b8; font-size: 0.875rem; margin: 0 0 8px 0;">Branding</p>
          <h3 style="color: white; font-size: 1.25rem; font-weight: 700; margin: 0;">TechVentures</h3>
        </div>
      </div>
      <div style="aspect-ratio: 4/5; border-radius: 20px; overflow: hidden; position: relative; background: #1e293b;">
        <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=500&fit=crop" style="width: 100%; height: 100%; object-fit: cover; opacity: 0.9;" alt="Project 2"/>
        <div style="position: absolute; bottom: 0; left: 0; right: 0; padding: 32px; background: linear-gradient(transparent, rgba(0,0,0,0.8));">
          <p style="color: #94a3b8; font-size: 0.875rem; margin: 0 0 8px 0;">Web Design</p>
          <h3 style="color: white; font-size: 1.25rem; font-weight: 700; margin: 0;">FinanceApp</h3>
        </div>
      </div>
      <div style="aspect-ratio: 4/5; border-radius: 20px; overflow: hidden; position: relative; background: #1e293b;">
        <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=500&fit=crop" style="width: 100%; height: 100%; object-fit: cover; opacity: 0.9;" alt="Project 3"/>
        <div style="position: absolute; bottom: 0; left: 0; right: 0; padding: 32px; background: linear-gradient(transparent, rgba(0,0,0,0.8));">
          <p style="color: #94a3b8; font-size: 0.875rem; margin: 0 0 8px 0;">Marketing</p>
          <h3 style="color: white; font-size: 1.25rem; font-weight: 700; margin: 0;">GrowthStartup</h3>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- STATS -->
<section class="agency-section" style="padding: 80px 40px; background: #6366f1;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div class="agency-stats-grid" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; text-align: center;">
      <div>
        <div style="font-size: 3.5rem; font-weight: 800; color: white;">8+</div>
        <div style="color: rgba(255,255,255,0.8);">Anos no mercado</div>
      </div>
      <div>
        <div style="font-size: 3.5rem; font-weight: 800; color: white;">150+</div>
        <div style="color: rgba(255,255,255,0.8);">Projetos entregues</div>
      </div>
      <div>
        <div style="font-size: 3.5rem; font-weight: 800; color: white;">50+</div>
        <div style="color: rgba(255,255,255,0.8);">Clientes ativos</div>
      </div>
      <div>
        <div style="font-size: 3.5rem; font-weight: 800; color: white;">98%</div>
        <div style="color: rgba(255,255,255,0.8);">Satisfação</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section id="contato" class="agency-section" style="padding: 120px 40px; background: #fafbfc;">
  <div style="max-width: 1000px; margin: 0 auto;">
    <div class="agency-cta-content" style="display: flex; justify-content: space-between; align-items: center; gap: 60px;">
      <div style="flex: 1;">
        <h2 class="agency-section-title" style="color: #0f172a; font-weight: 800; margin: 0 0 16px 0;">Tem um projeto em mente?</h2>
        <p style="color: #64748b; font-size: 1.125rem; line-height: 1.7;">Vamos conversar sobre como podemos ajudar sua empresa a alcançar novos patamares.</p>
      </div>
      <a href="mailto:contato@studiox.com" style="display: inline-flex; align-items: center; gap: 12px; padding: 20px 36px; background: #0f172a; color: white; text-decoration: none; border-radius: 12px; font-weight: 600; font-size: 1rem; white-space: nowrap;">
        Agendar uma conversa
        <span>→</span>
      </a>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer style="padding: 60px 40px 80px; background: #0f172a;">
  <div style="max-width: 1400px; margin: 0 auto;">
    <div class="agency-footer-grid" style="display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 60px; margin-bottom: 60px;">
      <div>
        <div style="font-size: 1.5rem; font-weight: 900; color: white; margin-bottom: 16px;">Studio<span style="color: #6366f1;">X</span></div>
        <p style="color: #94a3b8; line-height: 1.7; max-width: 280px;">Transformando marcas através do design e tecnologia desde 2016.</p>
      </div>
      <div>
        <h4 style="color: white; font-weight: 600; margin-bottom: 20px;">Serviços</h4>
        <div style="display: flex; flex-direction: column; gap: 12px;">
          <a href="#" style="color: #94a3b8; text-decoration: none;">Branding</a>
          <a href="#" style="color: #94a3b8; text-decoration: none;">Web Design</a>
          <a href="#" style="color: #94a3b8; text-decoration: none;">Marketing</a>
        </div>
      </div>
      <div>
        <h4 style="color: white; font-weight: 600; margin-bottom: 20px;">Empresa</h4>
        <div style="display: flex; flex-direction: column; gap: 12px;">
          <a href="#" style="color: #94a3b8; text-decoration: none;">Sobre</a>
          <a href="#" style="color: #94a3b8; text-decoration: none;">Carreiras</a>
          <a href="#" style="color: #94a3b8; text-decoration: none;">Contato</a>
        </div>
      </div>
      <div>
        <h4 style="color: white; font-weight: 600; margin-bottom: 20px;">Social</h4>
        <div style="display: flex; flex-direction: column; gap: 12px;">
          <a href="#" style="color: #94a3b8; text-decoration: none;">Instagram</a>
          <a href="#" style="color: #94a3b8; text-decoration: none;">LinkedIn</a>
          <a href="#" style="color: #94a3b8; text-decoration: none;">Behance</a>
        </div>
      </div>
    </div>
    <div style="border-top: 1px solid #1e293b; padding-top: 30px; display: flex; justify-content: space-between; flex-wrap: wrap; gap: 16px;">
      <p style="color: #64748b; font-size: 0.875rem; margin: 0;">© 2025 StudioX. Todos os direitos reservados.</p>
      <div class="agency-footer-links" style="display: flex; gap: 24px;">
        <a href="#" style="color: #64748b; text-decoration: none; font-size: 0.875rem;">Privacidade</a>
        <a href="#" style="color: #64748b; text-decoration: none; font-size: 0.875rem;">Termos</a>
      </div>
    </div>
  </div>
</footer>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'ecommerce-promo',
    name: 'Black Friday',
    description: 'Promoção de e-commerce com urgência e descontos',
    thumbnail: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=400&h=300&fit=crop',
    category: 'ecommerce',
    gjsHtml: `
<!-- BLACK FRIDAY HERO -->
<section style="background: #000000; padding: 80px 20px; position: relative; overflow: hidden;">
  <div style="position: absolute; inset: 0; background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><text y=\".9em\" font-size=\"90\">🎉</text></svg>') repeat; opacity: 0.03;"></div>
  <div style="max-width: 1200px; margin: 0 auto; text-align: center; position: relative;">
    <div style="display: inline-block; padding: 12px 32px; background: linear-gradient(135deg, #ef4444, #dc2626); border-radius: 8px; margin-bottom: 32px;">
      <span style="color: white; font-weight: 800; font-size: 1.25rem; letter-spacing: 2px;">BLACK FRIDAY</span>
    </div>
    <h1 style="font-size: 5rem; font-weight: 900; color: white; margin-bottom: 24px; line-height: 1;">
      ATÉ <span style="color: #fbbf24;">70% OFF</span>
    </h1>
    <p style="font-size: 1.5rem; color: #9ca3af; margin-bottom: 40px;">
      A maior promoção do ano. Ofertas imperdíveis por tempo limitado!
    </p>
    <div style="display: flex; justify-content: center; gap: 16px; margin-bottom: 48px;">
      <div style="padding: 20px 28px; background: #1f1f1f; border-radius: 12px; text-align: center;">
        <div style="font-size: 2.5rem; font-weight: 900; color: #fbbf24;">02</div>
        <div style="color: #6b7280; font-size: 12px; text-transform: uppercase;">Dias</div>
      </div>
      <div style="padding: 20px 28px; background: #1f1f1f; border-radius: 12px; text-align: center;">
        <div style="font-size: 2.5rem; font-weight: 900; color: #fbbf24;">15</div>
        <div style="color: #6b7280; font-size: 12px; text-transform: uppercase;">Horas</div>
      </div>
      <div style="padding: 20px 28px; background: #1f1f1f; border-radius: 12px; text-align: center;">
        <div style="font-size: 2.5rem; font-weight: 900; color: #fbbf24;">32</div>
        <div style="color: #6b7280; font-size: 12px; text-transform: uppercase;">Min</div>
      </div>
    </div>
    <a href="#" style="display: inline-block; padding: 22px 56px; background: linear-gradient(135deg, #fbbf24, #f59e0b); color: #000; font-weight: 900; font-size: 1.25rem; border-radius: 12px; text-decoration: none; box-shadow: 0 20px 40px rgba(251, 191, 36, 0.3);">
      VER OFERTAS →
    </a>
  </div>
</section>

<!-- PRODUCTS -->
<section style="padding: 80px 20px; background: #111111;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <h2 style="font-size: 2.5rem; font-weight: 800; color: white; text-align: center; margin-bottom: 48px;">⚡ Ofertas Relâmpago</h2>
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 24px;">
      <div style="background: #1f1f1f; border-radius: 20px; overflow: hidden; position: relative;">
        <span style="position: absolute; top: 16px; left: 16px; padding: 6px 16px; background: #ef4444; color: white; font-weight: 700; font-size: 14px; border-radius: 6px;">-50%</span>
        <img src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=300&h=300&fit=crop" style="width: 100%; height: 200px; object-fit: cover;" alt="Product"/>
        <div style="padding: 24px;">
          <h3 style="color: white; font-weight: 600; margin-bottom: 8px;">Headphone Premium</h3>
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="color: #6b7280; text-decoration: line-through;">R$ 599,90</span>
            <span style="color: #fbbf24; font-size: 1.5rem; font-weight: 800;">R$ 299,90</span>
          </div>
          <a href="#" style="display: block; text-align: center; padding: 14px; background: #fbbf24; color: #000; font-weight: 700; border-radius: 10px; text-decoration: none; margin-top: 16px;">COMPRAR</a>
        </div>
      </div>
      <div style="background: #1f1f1f; border-radius: 20px; overflow: hidden; position: relative;">
        <span style="position: absolute; top: 16px; left: 16px; padding: 6px 16px; background: #ef4444; color: white; font-weight: 700; font-size: 14px; border-radius: 6px;">-40%</span>
        <img src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=300&h=300&fit=crop" style="width: 100%; height: 200px; object-fit: cover;" alt="Product"/>
        <div style="padding: 24px;">
          <h3 style="color: white; font-weight: 600; margin-bottom: 8px;">Smart Watch Pro</h3>
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="color: #6b7280; text-decoration: line-through;">R$ 899,90</span>
            <span style="color: #fbbf24; font-size: 1.5rem; font-weight: 800;">R$ 539,90</span>
          </div>
          <a href="#" style="display: block; text-align: center; padding: 14px; background: #fbbf24; color: #000; font-weight: 700; border-radius: 10px; text-decoration: none; margin-top: 16px;">COMPRAR</a>
        </div>
      </div>
      <div style="background: #1f1f1f; border-radius: 20px; overflow: hidden; position: relative;">
        <span style="position: absolute; top: 16px; left: 16px; padding: 6px 16px; background: #ef4444; color: white; font-weight: 700; font-size: 14px; border-radius: 6px;">-60%</span>
        <img src="https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=300&h=300&fit=crop" style="width: 100%; height: 200px; object-fit: cover;" alt="Product"/>
        <div style="padding: 24px;">
          <h3 style="color: white; font-weight: 600; margin-bottom: 8px;">Câmera Profissional</h3>
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="color: #6b7280; text-decoration: line-through;">R$ 2.499,90</span>
            <span style="color: #fbbf24; font-size: 1.5rem; font-weight: 800;">R$ 999,90</span>
          </div>
          <a href="#" style="display: block; text-align: center; padding: 14px; background: #fbbf24; color: #000; font-weight: 700; border-radius: 10px; text-decoration: none; margin-top: 16px;">COMPRAR</a>
        </div>
      </div>
    </div>
  </div>
</section>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'mobile-app',
    name: 'App Mobile',
    description: 'Página de download para aplicativo mobile',
    thumbnail: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400&h=300&fit=crop',
    category: 'saas',
    gjsHtml: `
<style>
  * { box-sizing: border-box; }
  .app-title { font-size: clamp(2.5rem, 6vw, 4rem); }
  .app-section-title { font-size: clamp(2rem, 4vw, 3rem); }
  .app-text { font-size: clamp(1rem, 1.5vw, 1.25rem); }
  @media (max-width: 1024px) {
    .app-hero-grid { grid-template-columns: 1fr !important; text-align: center !important; }
    .app-hero-phone { margin-top: 40px !important; }
    .app-hero-buttons { justify-content: center !important; }
    .app-hero-stats { justify-content: center !important; }
  }
  @media (max-width: 768px) {
    .app-hero { padding: 80px 20px !important; }
    .app-section { padding: 80px 20px !important; }
    .app-features-grid { grid-template-columns: 1fr 1fr !important; }
    .app-testimonials-grid { grid-template-columns: 1fr !important; }
    .app-hero-phone img { max-width: 220px !important; }
    .app-cta-grid { grid-template-columns: 1fr !important; text-align: center !important; }
    .app-cta-phone { display: none !important; }
  }
  @media (max-width: 480px) {
    .app-features-grid { grid-template-columns: 1fr !important; }
    .app-hero-buttons { flex-direction: column !important; }
    .app-hero-btn { width: 100% !important; justify-content: center !important; }
    .app-hero-stats { flex-direction: column !important; gap: 16px !important; }
  }
</style>

<!-- HERO -->
<section class="app-hero" style="background: linear-gradient(180deg, #0a0a0a 0%, #171717 100%); padding: 100px 40px; min-height: 100vh; display: flex; align-items: center;">
  <div class="app-hero-grid" style="max-width: 1300px; margin: 0 auto; display: grid; grid-template-columns: 1fr auto; gap: 80px; align-items: center;">
    <div>
      <div style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 18px; background: rgba(16, 185, 129, 0.15); border: 1px solid rgba(16, 185, 129, 0.3); border-radius: 100px; margin-bottom: 32px;">
        <span style="font-size: 14px;">🚀</span>
        <span style="color: #34d399; font-size: 0.875rem; font-weight: 600;">Novo: PIX instantâneo 24h</span>
      </div>
      <h1 class="app-title" style="color: white; font-weight: 800; line-height: 1.1; margin: 0 0 24px 0;">
        Suas finanças no<br/>
        <span style="background: linear-gradient(90deg, #10b981, #34d399); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">controle total</span>
      </h1>
      <p class="app-text" style="color: #a1a1aa; line-height: 1.8; margin-bottom: 40px; max-width: 480px;">
        Organize gastos, invista com inteligência e acompanhe seu patrimônio em tempo real. O app financeiro mais completo do Brasil.
      </p>
      <div class="app-hero-buttons" style="display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 48px;">
        <a href="#" class="app-hero-btn" style="display: inline-flex; align-items: center; gap: 14px; padding: 16px 24px; background: white; border-radius: 14px; text-decoration: none;">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="#000"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
          <div style="text-align: left;">
            <div style="font-size: 11px; color: #6b7280; font-weight: 500;">Baixar na</div>
            <div style="font-size: 16px; font-weight: 700; color: #0a0a0a;">App Store</div>
          </div>
        </a>
        <a href="#" class="app-hero-btn" style="display: inline-flex; align-items: center; gap: 14px; padding: 16px 24px; background: white; border-radius: 14px; text-decoration: none;">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="#000"><path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5ZM16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12ZM20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.5 12.92 20.16 13.19L17.89 14.5L15.39 12L17.89 9.5L20.16 10.81ZM6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z"/></svg>
          <div style="text-align: left;">
            <div style="font-size: 11px; color: #6b7280; font-weight: 500;">Disponível no</div>
            <div style="font-size: 16px; font-weight: 700; color: #0a0a0a;">Google Play</div>
          </div>
        </a>
      </div>
      <div class="app-hero-stats" style="display: flex; gap: 48px;">
        <div>
          <div style="font-size: 2rem; font-weight: 800; color: white;">4.9<span style="color: #fbbf24;">★</span></div>
          <div style="color: #71717a; font-size: 0.875rem;">+85k avaliações</div>
        </div>
        <div>
          <div style="font-size: 2rem; font-weight: 800; color: white;">5M+</div>
          <div style="color: #71717a; font-size: 0.875rem;">Downloads</div>
        </div>
        <div>
          <div style="font-size: 2rem; font-weight: 800; color: white;">R$2B+</div>
          <div style="color: #71717a; font-size: 0.875rem;">Transacionados</div>
        </div>
      </div>
    </div>
    <div class="app-hero-phone" style="position: relative;">
      <div style="position: absolute; inset: -40px; background: radial-gradient(circle, rgba(16, 185, 129, 0.2) 0%, transparent 70%);"></div>
      <img src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=280&h=560&fit=crop" style="position: relative; border-radius: 40px; box-shadow: 0 60px 120px rgba(0,0,0,0.5);" alt="App"/>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="app-section" style="padding: 120px 40px; background: #fafafa;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div style="text-align: center; margin-bottom: 64px;">
      <span style="color: #10b981; font-weight: 600; font-size: 0.875rem; text-transform: uppercase; letter-spacing: 2px;">Funcionalidades</span>
      <h2 class="app-section-title" style="color: #0a0a0a; font-weight: 800; margin: 16px 0 0 0;">Tudo que você precisa em um só app</h2>
    </div>
    <div class="app-features-grid" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px;">
      <div style="padding: 32px; background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.05);">
        <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #10b981, #059669); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
          <span style="font-size: 24px;">💳</span>
        </div>
        <h3 style="font-size: 1.125rem; font-weight: 700; color: #0a0a0a; margin-bottom: 8px;">Controle de Gastos</h3>
        <p style="color: #71717a; line-height: 1.6; font-size: 0.95rem;">Categorize automaticamente e veja para onde vai seu dinheiro.</p>
      </div>
      <div style="padding: 32px; background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.05);">
        <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
          <span style="font-size: 24px;">📈</span>
        </div>
        <h3 style="font-size: 1.125rem; font-weight: 700; color: #0a0a0a; margin-bottom: 8px;">Investimentos</h3>
        <p style="color: #71717a; line-height: 1.6; font-size: 0.95rem;">Invista em renda fixa e variável a partir de apenas R$1.</p>
      </div>
      <div style="padding: 32px; background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.05);">
        <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #f59e0b, #d97706); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
          <span style="font-size: 24px;">🎯</span>
        </div>
        <h3 style="font-size: 1.125rem; font-weight: 700; color: #0a0a0a; margin-bottom: 8px;">Metas Financeiras</h3>
        <p style="color: #71717a; line-height: 1.6; font-size: 0.95rem;">Defina objetivos e acompanhe seu progresso em tempo real.</p>
      </div>
      <div style="padding: 32px; background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.05);">
        <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #ec4899, #db2777); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
          <span style="font-size: 24px;">⚡</span>
        </div>
        <h3 style="font-size: 1.125rem; font-weight: 700; color: #0a0a0a; margin-bottom: 8px;">PIX Instantâneo</h3>
        <p style="color: #71717a; line-height: 1.6; font-size: 0.95rem;">Transfira e receba dinheiro 24h por dia, sem taxas.</p>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="app-section" style="padding: 120px 40px; background: white;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div style="text-align: center; margin-bottom: 64px;">
      <span style="color: #10b981; font-weight: 600; font-size: 0.875rem; text-transform: uppercase; letter-spacing: 2px;">Depoimentos</span>
      <h2 class="app-section-title" style="color: #0a0a0a; font-weight: 800; margin: 16px 0 0 0;">O que nossos usuários dizem</h2>
    </div>
    <div class="app-testimonials-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px;">
      <div style="padding: 32px; background: #fafafa; border-radius: 20px;">
        <div style="color: #fbbf24; font-size: 18px; margin-bottom: 16px;">★★★★★</div>
        <p style="color: #3f3f46; line-height: 1.7; margin-bottom: 24px;">"Finalmente consegui organizar minha vida financeira. O app é super intuitivo e as metas me ajudam a economizar!"</p>
        <div style="display: flex; align-items: center; gap: 12px;">
          <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=48&h=48&fit=crop" style="width: 48px; height: 48px; border-radius: 50%;" alt=""/>
          <div>
            <div style="font-weight: 600; color: #0a0a0a;">Mariana S.</div>
            <div style="font-size: 0.875rem; color: #71717a;">Usuária há 2 anos</div>
          </div>
        </div>
      </div>
      <div style="padding: 32px; background: #fafafa; border-radius: 20px;">
        <div style="color: #fbbf24; font-size: 18px; margin-bottom: 16px;">★★★★★</div>
        <p style="color: #3f3f46; line-height: 1.7; margin-bottom: 24px;">"Comecei a investir pelo app e já consegui um retorno incrível. A interface é muito fácil de usar."</p>
        <div style="display: flex; align-items: center; gap: 12px;">
          <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=48&h=48&fit=crop" style="width: 48px; height: 48px; border-radius: 50%;" alt=""/>
          <div>
            <div style="font-weight: 600; color: #0a0a0a;">Rafael M.</div>
            <div style="font-size: 0.875rem; color: #71717a;">Investidor iniciante</div>
          </div>
        </div>
      </div>
      <div style="padding: 32px; background: #fafafa; border-radius: 20px;">
        <div style="color: #fbbf24; font-size: 18px; margin-bottom: 16px;">★★★★★</div>
        <p style="color: #3f3f46; line-height: 1.7; margin-bottom: 24px;">"O PIX 24h salvou minha vida várias vezes! Transferências instantâneas e sem taxas."</p>
        <div style="display: flex; align-items: center; gap: 12px;">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=48&h=48&fit=crop" style="width: 48px; height: 48px; border-radius: 50%;" alt=""/>
          <div>
            <div style="font-weight: 600; color: #0a0a0a;">Carla P.</div>
            <div style="font-size: 0.875rem; color: #71717a;">Empreendedora</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="app-section" style="padding: 120px 40px; background: linear-gradient(135deg, #0a0a0a 0%, #171717 100%);">
  <div style="max-width: 1100px; margin: 0 auto;">
    <div class="app-cta-grid" style="display: grid; grid-template-columns: 1fr auto; gap: 80px; align-items: center;">
      <div>
        <h2 class="app-section-title" style="color: white; font-weight: 800; margin: 0 0 20px 0;">Comece agora sua jornada financeira</h2>
        <p style="color: #a1a1aa; font-size: 1.125rem; line-height: 1.7; margin-bottom: 40px;">Baixe grátis e descubra como é fácil ter controle total das suas finanças. Sem taxas escondidas.</p>
        <div style="display: flex; gap: 16px; flex-wrap: wrap;">
          <a href="#" style="display: inline-flex; align-items: center; gap: 12px; padding: 16px 28px; background: #10b981; border-radius: 12px; text-decoration: none; color: white; font-weight: 600;">
            Baixar para iOS
          </a>
          <a href="#" style="display: inline-flex; align-items: center; gap: 12px; padding: 16px 28px; background: white; border-radius: 12px; text-decoration: none; color: #0a0a0a; font-weight: 600;">
            Baixar para Android
          </a>
        </div>
      </div>
      <div class="app-cta-phone">
        <img src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=200&h=400&fit=crop" style="border-radius: 32px; box-shadow: 0 40px 80px rgba(0,0,0,0.4);" alt="App"/>
      </div>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer style="padding: 40px; background: #0a0a0a; text-align: center;">
  <div style="font-size: 1.25rem; font-weight: 800; color: white; margin-bottom: 16px;">Finança<span style="color: #10b981;">+</span></div>
  <p style="color: #71717a; font-size: 0.875rem;">© 2025 Finança+. Todos os direitos reservados.</p>
</footer>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'course-sales',
    name: 'Curso Online',
    description: 'Venda de cursos e infoprodutos',
    thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=300&fit=crop',
    category: 'lead-magnet',
    gjsHtml: `
<style>
  * { box-sizing: border-box; }
  .course-hero { background: linear-gradient(180deg, #0f0f23 0%, #1a1a3e 50%, #0f0f23 100%); padding: clamp(60px, 10vw, 120px) 20px; position: relative; overflow: hidden; }
  .course-hero::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 80% 50% at 50% 0%, rgba(99, 102, 241, 0.15), transparent), radial-gradient(ellipse 60% 40% at 80% 100%, rgba(168, 85, 247, 0.1), transparent); pointer-events: none; }
  .course-hero-grid { max-width: 1300px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; position: relative; z-index: 1; }
  .course-hero-content { }
  .course-badge { display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.2)); border: 1px solid rgba(99, 102, 241, 0.3); border-radius: 50px; margin-bottom: 28px; }
  .course-badge span { color: #a5b4fc; font-size: 14px; font-weight: 600; letter-spacing: 0.5px; }
  .course-hero h1 { font-size: clamp(2.5rem, 5vw, 4rem); font-weight: 900; color: white; line-height: 1.1; margin: 0 0 24px 0; }
  .course-hero h1 em { font-style: normal; background: linear-gradient(135deg, #818cf8, #c084fc); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .course-hero-desc { font-size: clamp(1.1rem, 2vw, 1.35rem); color: #94a3b8; line-height: 1.7; margin-bottom: 32px; }
  .course-stats { display: flex; gap: 32px; margin-bottom: 40px; flex-wrap: wrap; }
  .course-stat { text-align: left; }
  .course-stat-number { font-size: 2rem; font-weight: 800; color: white; margin-bottom: 4px; }
  .course-stat-label { font-size: 14px; color: #64748b; }
  .course-hero-cta { display: flex; align-items: center; gap: 24px; flex-wrap: wrap; }
  .course-price { }
  .course-price-old { display: block; font-size: 1rem; color: #64748b; text-decoration: line-through; margin-bottom: 4px; }
  .course-price-current { font-size: clamp(2.5rem, 5vw, 3.5rem); font-weight: 900; color: white; }
  .course-price-current small { font-size: 1rem; font-weight: 500; color: #94a3b8; }
  .course-btn-primary { display: inline-flex; align-items: center; gap: 12px; padding: 20px 40px; background: linear-gradient(135deg, #6366f1, #8b5cf6); color: white; font-weight: 700; font-size: 1.1rem; border-radius: 14px; text-decoration: none; transition: all 0.3s; box-shadow: 0 20px 40px rgba(99, 102, 241, 0.3); }
  .course-btn-primary:hover { transform: translateY(-3px); box-shadow: 0 25px 50px rgba(99, 102, 241, 0.4); }
  .course-video-preview { position: relative; border-radius: 24px; overflow: hidden; box-shadow: 0 40px 80px rgba(0, 0, 0, 0.5); }
  .course-video-preview img { width: 100%; display: block; }
  .course-video-play { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.4); }
  .course-video-play span { width: 80px; height: 80px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 32px; cursor: pointer; transition: transform 0.3s; }
  .course-video-play span:hover { transform: scale(1.1); }

  .course-social-proof { background: #0f0f23; padding: 60px 20px; border-top: 1px solid rgba(255,255,255,0.05); border-bottom: 1px solid rgba(255,255,255,0.05); }
  .course-social-proof-inner { max-width: 1200px; margin: 0 auto; display: flex; justify-content: center; gap: 60px; flex-wrap: wrap; align-items: center; }
  .course-social-item { display: flex; align-items: center; gap: 16px; }
  .course-social-icon { width: 56px; height: 56px; background: rgba(99, 102, 241, 0.1); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 24px; }
  .course-social-text { }
  .course-social-number { font-size: 1.5rem; font-weight: 800; color: white; }
  .course-social-label { font-size: 14px; color: #64748b; }

  .course-curriculum { padding: clamp(60px, 10vw, 120px) 20px; background: linear-gradient(180deg, #fafbfc 0%, #f1f5f9 100%); }
  .course-curriculum-inner { max-width: 1000px; margin: 0 auto; }
  .course-section-header { text-align: center; margin-bottom: 60px; }
  .course-section-tag { display: inline-block; padding: 8px 20px; background: linear-gradient(135deg, #6366f1, #8b5cf6); color: white; font-size: 12px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; border-radius: 50px; margin-bottom: 20px; }
  .course-section-title { font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #0f172a; margin: 0 0 16px 0; }
  .course-section-desc { font-size: 1.2rem; color: #64748b; max-width: 600px; margin: 0 auto; }
  .course-modules { display: flex; flex-direction: column; gap: 16px; }
  .course-module { background: white; border-radius: 20px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.05); border: 1px solid #e2e8f0; }
  .course-module-header { padding: 28px 32px; display: flex; align-items: center; gap: 20px; cursor: pointer; transition: background 0.3s; }
  .course-module-header:hover { background: #f8fafc; }
  .course-module-num { width: 52px; height: 52px; background: linear-gradient(135deg, #6366f1, #8b5cf6); border-radius: 14px; display: flex; align-items: center; justify-content: center; color: white; font-weight: 800; font-size: 1.2rem; flex-shrink: 0; }
  .course-module-info { flex: 1; }
  .course-module-title { font-size: 1.2rem; font-weight: 700; color: #0f172a; margin: 0 0 6px 0; }
  .course-module-meta { font-size: 14px; color: #64748b; }
  .course-module-meta span { margin-right: 16px; }
  .course-module-arrow { font-size: 20px; color: #94a3b8; }

  .course-instructor { padding: clamp(60px, 10vw, 120px) 20px; background: white; }
  .course-instructor-inner { max-width: 1000px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1.5fr; gap: 60px; align-items: center; }
  .course-instructor-img { position: relative; }
  .course-instructor-img img { width: 100%; border-radius: 24px; box-shadow: 0 30px 60px rgba(0,0,0,0.15); }
  .course-instructor-badge { position: absolute; bottom: -20px; right: -20px; background: linear-gradient(135deg, #6366f1, #8b5cf6); padding: 16px 24px; border-radius: 16px; color: white; font-weight: 700; box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3); }
  .course-instructor-content h3 { font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0f172a; margin: 0 0 12px 0; }
  .course-instructor-role { font-size: 1.1rem; color: #6366f1; font-weight: 600; margin-bottom: 24px; }
  .course-instructor-bio { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 32px; }
  .course-instructor-stats { display: flex; gap: 40px; padding-top: 24px; border-top: 1px solid #e2e8f0; }
  .course-instructor-stat { }
  .course-instructor-stat-num { font-size: 1.8rem; font-weight: 800; color: #0f172a; }
  .course-instructor-stat-label { font-size: 14px; color: #64748b; }

  .course-testimonials { padding: clamp(60px, 10vw, 120px) 20px; background: linear-gradient(180deg, #0f0f23 0%, #1a1a3e 100%); }
  .course-testimonials-inner { max-width: 1200px; margin: 0 auto; }
  .course-testimonials .course-section-title { color: white; }
  .course-testimonials .course-section-desc { color: #94a3b8; }
  .course-testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 60px; }
  .course-testimonial { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 20px; padding: 32px; }
  .course-testimonial-stars { color: #fbbf24; font-size: 18px; margin-bottom: 16px; }
  .course-testimonial-text { font-size: 1rem; color: #e2e8f0; line-height: 1.7; margin-bottom: 24px; }
  .course-testimonial-author { display: flex; align-items: center; gap: 16px; }
  .course-testimonial-avatar { width: 48px; height: 48px; border-radius: 50%; object-fit: cover; }
  .course-testimonial-name { font-weight: 600; color: white; }
  .course-testimonial-role { font-size: 14px; color: #64748b; }

  .course-bonus { padding: clamp(60px, 10vw, 120px) 20px; background: linear-gradient(180deg, #fafbfc 0%, white 100%); }
  .course-bonus-inner { max-width: 1000px; margin: 0 auto; }
  .course-bonus-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; margin-top: 60px; }
  .course-bonus-card { background: white; border: 2px solid #e2e8f0; border-radius: 20px; padding: 32px; transition: all 0.3s; }
  .course-bonus-card:hover { border-color: #6366f1; transform: translateY(-4px); box-shadow: 0 20px 40px rgba(99, 102, 241, 0.1); }
  .course-bonus-icon { width: 64px; height: 64px; background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.1)); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 28px; margin-bottom: 20px; }
  .course-bonus-title { font-size: 1.3rem; font-weight: 700; color: #0f172a; margin: 0 0 12px 0; }
  .course-bonus-desc { font-size: 1rem; color: #64748b; line-height: 1.7; margin-bottom: 16px; }
  .course-bonus-value { font-size: 14px; color: #6366f1; font-weight: 600; }

  .course-faq { padding: clamp(60px, 10vw, 120px) 20px; background: white; }
  .course-faq-inner { max-width: 800px; margin: 0 auto; }
  .course-faq-list { margin-top: 60px; }
  .course-faq-item { border-bottom: 1px solid #e2e8f0; }
  .course-faq-question { padding: 28px 0; font-size: 1.15rem; font-weight: 600; color: #0f172a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; }
  .course-faq-question span { font-size: 24px; color: #6366f1; }
  .course-faq-answer { padding: 0 0 28px 0; font-size: 1rem; color: #64748b; line-height: 1.8; }

  .course-pricing { padding: clamp(60px, 10vw, 120px) 20px; background: linear-gradient(180deg, #0f0f23 0%, #1a1a3e 50%, #0f0f23 100%); position: relative; }
  .course-pricing::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 60% 40% at 50% 50%, rgba(99, 102, 241, 0.1), transparent); pointer-events: none; }
  .course-pricing-inner { max-width: 600px; margin: 0 auto; position: relative; z-index: 1; }
  .course-pricing .course-section-title { color: white; }
  .course-pricing .course-section-desc { color: #94a3b8; }
  .course-pricing-card { background: rgba(255,255,255,0.05); border: 2px solid rgba(99, 102, 241, 0.3); border-radius: 32px; padding: 48px; margin-top: 60px; text-align: center; }
  .course-pricing-badge { display: inline-block; padding: 8px 20px; background: linear-gradient(135deg, #dc2626, #ef4444); color: white; font-size: 12px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; border-radius: 50px; margin-bottom: 24px; }
  .course-pricing-old { font-size: 1.5rem; color: #64748b; text-decoration: line-through; margin-bottom: 8px; }
  .course-pricing-current { font-size: clamp(3rem, 6vw, 4.5rem); font-weight: 900; color: white; margin-bottom: 8px; }
  .course-pricing-installment { font-size: 1.1rem; color: #94a3b8; margin-bottom: 32px; }
  .course-pricing-features { text-align: left; margin-bottom: 40px; }
  .course-pricing-feature { display: flex; align-items: center; gap: 12px; padding: 12px 0; color: #e2e8f0; font-size: 1rem; }
  .course-pricing-feature span { color: #22c55e; font-size: 20px; }
  .course-pricing-cta { display: block; width: 100%; padding: 24px; background: linear-gradient(135deg, #6366f1, #8b5cf6); color: white; font-weight: 800; font-size: 1.2rem; border-radius: 16px; text-decoration: none; transition: all 0.3s; box-shadow: 0 20px 40px rgba(99, 102, 241, 0.3); }
  .course-pricing-cta:hover { transform: translateY(-3px); box-shadow: 0 25px 50px rgba(99, 102, 241, 0.4); }
  .course-pricing-secure { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 24px; color: #64748b; font-size: 14px; }

  .course-guarantee { padding: clamp(60px, 10vw, 100px) 20px; background: linear-gradient(135deg, #ecfdf5, #d1fae5); }
  .course-guarantee-inner { max-width: 800px; margin: 0 auto; display: flex; align-items: center; gap: 40px; }
  .course-guarantee-icon { width: 120px; height: 120px; background: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 56px; box-shadow: 0 20px 40px rgba(16, 185, 129, 0.2); flex-shrink: 0; }
  .course-guarantee-content h3 { font-size: clamp(1.5rem, 3vw, 2rem); font-weight: 800; color: #065f46; margin: 0 0 16px 0; }
  .course-guarantee-content p { font-size: 1.1rem; color: #047857; line-height: 1.7; margin: 0; }

  .course-footer { padding: 60px 20px; background: #0f0f23; text-align: center; }
  .course-footer p { color: #64748b; font-size: 14px; margin: 0; }

  @media (max-width: 992px) {
    .course-hero-grid { grid-template-columns: 1fr; gap: 50px; text-align: center; }
    .course-stats { justify-content: center; }
    .course-hero-cta { justify-content: center; }
    .course-instructor-inner { grid-template-columns: 1fr; gap: 40px; text-align: center; }
    .course-instructor-badge { right: 50%; transform: translateX(50%); }
    .course-instructor-stats { justify-content: center; }
    .course-testimonials-grid { grid-template-columns: 1fr; }
    .course-bonus-grid { grid-template-columns: 1fr; }
  }
  @media (max-width: 768px) {
    .course-social-proof-inner { gap: 30px; }
    .course-module-header { padding: 20px; }
    .course-guarantee-inner { flex-direction: column; text-align: center; }
    .course-guarantee-icon { width: 100px; height: 100px; font-size: 44px; }
  }
</style>

<!-- HERO -->
<section class="course-hero">
  <div class="course-hero-grid">
    <div class="course-hero-content">
      <div class="course-badge">
        <span>🎓 Curso Completo + Certificado</span>
      </div>
      <h1>Domine <em>Python</em> do Zero ao Avançado em 8 Semanas</h1>
      <p class="course-hero-desc">O método definitivo para você se tornar um programador Python completo e conquistar as melhores vagas do mercado de tecnologia.</p>
      <div class="course-stats">
        <div class="course-stat">
          <div class="course-stat-number">+150</div>
          <div class="course-stat-label">Aulas em Vídeo</div>
        </div>
        <div class="course-stat">
          <div class="course-stat-number">8</div>
          <div class="course-stat-label">Semanas</div>
        </div>
        <div class="course-stat">
          <div class="course-stat-number">12</div>
          <div class="course-stat-label">Projetos Práticos</div>
        </div>
      </div>
      <div class="course-hero-cta">
        <div class="course-price">
          <span class="course-price-old">De R$ 997,00</span>
          <span class="course-price-current">R$ 297 <small>ou 12x R$29,70</small></span>
        </div>
        <a href="#pricing" class="course-btn-primary">QUERO ME MATRICULAR →</a>
      </div>
    </div>
    <div class="course-video-preview">
      <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop" alt="Preview do Curso"/>
      <div class="course-video-play">
        <span>▶</span>
      </div>
    </div>
  </div>
</section>

<!-- SOCIAL PROOF -->
<section class="course-social-proof">
  <div class="course-social-proof-inner">
    <div class="course-social-item">
      <div class="course-social-icon">👥</div>
      <div class="course-social-text">
        <div class="course-social-number">+12.500</div>
        <div class="course-social-label">Alunos matriculados</div>
      </div>
    </div>
    <div class="course-social-item">
      <div class="course-social-icon">⭐</div>
      <div class="course-social-text">
        <div class="course-social-number">4.9/5.0</div>
        <div class="course-social-label">Avaliação média</div>
      </div>
    </div>
    <div class="course-social-item">
      <div class="course-social-icon">💼</div>
      <div class="course-social-text">
        <div class="course-social-number">89%</div>
        <div class="course-social-label">Conseguiram emprego</div>
      </div>
    </div>
  </div>
</section>

<!-- CURRICULUM -->
<section class="course-curriculum">
  <div class="course-curriculum-inner">
    <div class="course-section-header">
      <span class="course-section-tag">Conteúdo Completo</span>
      <h2 class="course-section-title">O que você vai aprender</h2>
      <p class="course-section-desc">Um currículo completo que vai te levar do zero ao profissional em Python</p>
    </div>
    <div class="course-modules">
      <div class="course-module">
        <div class="course-module-header">
          <div class="course-module-num">1</div>
          <div class="course-module-info">
            <h4 class="course-module-title">Fundamentos do Python</h4>
            <div class="course-module-meta"><span>📹 18 aulas</span><span>⏱️ 4h 30min</span></div>
          </div>
          <span class="course-module-arrow">›</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-header">
          <div class="course-module-num">2</div>
          <div class="course-module-info">
            <h4 class="course-module-title">Estruturas de Dados e Algoritmos</h4>
            <div class="course-module-meta"><span>📹 22 aulas</span><span>⏱️ 5h 15min</span></div>
          </div>
          <span class="course-module-arrow">›</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-header">
          <div class="course-module-num">3</div>
          <div class="course-module-info">
            <h4 class="course-module-title">Programação Orientada a Objetos</h4>
            <div class="course-module-meta"><span>📹 20 aulas</span><span>⏱️ 4h 45min</span></div>
          </div>
          <span class="course-module-arrow">›</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-header">
          <div class="course-module-num">4</div>
          <div class="course-module-info">
            <h4 class="course-module-title">Web com Django e Flask</h4>
            <div class="course-module-meta"><span>📹 35 aulas</span><span>⏱️ 8h 30min</span></div>
          </div>
          <span class="course-module-arrow">›</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-header">
          <div class="course-module-num">5</div>
          <div class="course-module-info">
            <h4 class="course-module-title">Data Science e Machine Learning</h4>
            <div class="course-module-meta"><span>📹 40 aulas</span><span>⏱️ 10h 00min</span></div>
          </div>
          <span class="course-module-arrow">›</span>
        </div>
      </div>
      <div class="course-module">
        <div class="course-module-header">
          <div class="course-module-num">6</div>
          <div class="course-module-info">
            <h4 class="course-module-title">Projetos Profissionais</h4>
            <div class="course-module-meta"><span>📹 25 aulas</span><span>⏱️ 6h 00min</span></div>
          </div>
          <span class="course-module-arrow">›</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- INSTRUCTOR -->
<section class="course-instructor">
  <div class="course-instructor-inner">
    <div class="course-instructor-img">
      <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=500&fit=crop" alt="Instrutor"/>
      <div class="course-instructor-badge">+15 anos de experiência</div>
    </div>
    <div class="course-instructor-content">
      <h3>Carlos Eduardo Silva</h3>
      <div class="course-instructor-role">Senior Software Engineer & Educador</div>
      <p class="course-instructor-bio">Engenheiro de Software com mais de 15 anos de experiência em grandes empresas de tecnologia. Já formei mais de 12.000 alunos em Python e ajudei centenas a conquistarem suas primeiras vagas na área de tecnologia. Minha missão é tornar a programação acessível e prática para todos.</p>
      <div class="course-instructor-stats">
        <div class="course-instructor-stat">
          <div class="course-instructor-stat-num">12.500+</div>
          <div class="course-instructor-stat-label">Alunos formados</div>
        </div>
        <div class="course-instructor-stat">
          <div class="course-instructor-stat-num">4.9</div>
          <div class="course-instructor-stat-label">Avaliação média</div>
        </div>
        <div class="course-instructor-stat">
          <div class="course-instructor-stat-num">8</div>
          <div class="course-instructor-stat-label">Cursos publicados</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- TESTIMONIALS -->
<section class="course-testimonials">
  <div class="course-testimonials-inner">
    <div class="course-section-header">
      <span class="course-section-tag">Depoimentos</span>
      <h2 class="course-section-title">O que nossos alunos dizem</h2>
      <p class="course-section-desc">Histórias reais de transformação de quem já passou pelo curso</p>
    </div>
    <div class="course-testimonials-grid">
      <div class="course-testimonial">
        <div class="course-testimonial-stars">⭐⭐⭐⭐⭐</div>
        <p class="course-testimonial-text">"Consegui minha primeira vaga como desenvolvedor Python 2 meses após terminar o curso. O conteúdo é muito prático e o professor explica de forma clara."</p>
        <div class="course-testimonial-author">
          <img class="course-testimonial-avatar" src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop" alt=""/>
          <div>
            <div class="course-testimonial-name">Rafael Santos</div>
            <div class="course-testimonial-role">Desenvolvedor Python Jr.</div>
          </div>
        </div>
      </div>
      <div class="course-testimonial">
        <div class="course-testimonial-stars">⭐⭐⭐⭐⭐</div>
        <p class="course-testimonial-text">"Já fiz vários cursos online, mas esse é de longe o mais completo. Os projetos práticos fizeram toda diferença no meu aprendizado."</p>
        <div class="course-testimonial-author">
          <img class="course-testimonial-avatar" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop" alt=""/>
          <div>
            <div class="course-testimonial-name">Ana Paula Costa</div>
            <div class="course-testimonial-role">Data Scientist</div>
          </div>
        </div>
      </div>
      <div class="course-testimonial">
        <div class="course-testimonial-stars">⭐⭐⭐⭐⭐</div>
        <p class="course-testimonial-text">"Mudou completamente minha carreira. Saí de analista para desenvolvedor e dobrei meu salário. Recomendo demais!"</p>
        <div class="course-testimonial-author">
          <img class="course-testimonial-avatar" src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop" alt=""/>
          <div>
            <div class="course-testimonial-name">Lucas Mendes</div>
            <div class="course-testimonial-role">Full Stack Developer</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- BONUS -->
<section class="course-bonus">
  <div class="course-bonus-inner">
    <div class="course-section-header">
      <span class="course-section-tag">Bônus Exclusivos</span>
      <h2 class="course-section-title">Você também vai receber</h2>
      <p class="course-section-desc">Materiais extras para acelerar ainda mais seu aprendizado</p>
    </div>
    <div class="course-bonus-grid">
      <div class="course-bonus-card">
        <div class="course-bonus-icon">📚</div>
        <h4 class="course-bonus-title">E-book: Python Pro Tips</h4>
        <p class="course-bonus-desc">100 dicas e truques avançados para escrever código Python mais eficiente e profissional.</p>
        <span class="course-bonus-value">Valor: R$ 97,00 - GRÁTIS</span>
      </div>
      <div class="course-bonus-card">
        <div class="course-bonus-icon">💬</div>
        <h4 class="course-bonus-title">Comunidade Exclusiva</h4>
        <p class="course-bonus-desc">Acesso ao grupo VIP no Discord com outros alunos e suporte direto com o professor.</p>
        <span class="course-bonus-value">Valor: R$ 197,00/ano - GRÁTIS</span>
      </div>
      <div class="course-bonus-card">
        <div class="course-bonus-icon">🎯</div>
        <h4 class="course-bonus-title">Mentoria de Carreira</h4>
        <p class="course-bonus-desc">2 sessões ao vivo de orientação profissional para preparar seu currículo e LinkedIn.</p>
        <span class="course-bonus-value">Valor: R$ 297,00 - GRÁTIS</span>
      </div>
      <div class="course-bonus-card">
        <div class="course-bonus-icon">📝</div>
        <h4 class="course-bonus-title">Simulado de Entrevistas</h4>
        <p class="course-bonus-desc">50 questões técnicas mais cobradas em entrevistas para vagas de Python.</p>
        <span class="course-bonus-value">Valor: R$ 47,00 - GRÁTIS</span>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="course-faq">
  <div class="course-faq-inner">
    <div class="course-section-header">
      <span class="course-section-tag">Dúvidas Frequentes</span>
      <h2 class="course-section-title">Perguntas e Respostas</h2>
    </div>
    <div class="course-faq-list">
      <div class="course-faq-item">
        <div class="course-faq-question">Preciso saber programar para fazer o curso? <span>+</span></div>
        <div class="course-faq-answer">Não! O curso foi desenvolvido para iniciantes absolutos. Começamos do zero e vamos avançando gradualmente. Basta ter um computador e vontade de aprender.</div>
      </div>
      <div class="course-faq-item">
        <div class="course-faq-question">Por quanto tempo terei acesso ao curso? <span>+</span></div>
        <div class="course-faq-answer">O acesso é vitalício! Uma vez matriculado, você terá acesso para sempre, incluindo todas as atualizações futuras do conteúdo.</div>
      </div>
      <div class="course-faq-item">
        <div class="course-faq-question">O certificado é reconhecido? <span>+</span></div>
        <div class="course-faq-answer">Sim! Ao concluir o curso, você receberá um certificado de conclusão que pode ser compartilhado no LinkedIn e adicionado ao seu currículo.</div>
      </div>
      <div class="course-faq-item">
        <div class="course-faq-question">E se eu não gostar do curso? <span>+</span></div>
        <div class="course-faq-answer">Oferecemos garantia incondicional de 30 dias. Se por qualquer motivo você não estiver satisfeito, devolvemos 100% do seu investimento.</div>
      </div>
    </div>
  </div>
</section>

<!-- PRICING -->
<section id="pricing" class="course-pricing">
  <div class="course-pricing-inner">
    <div class="course-section-header">
      <span class="course-section-tag">Oferta Especial</span>
      <h2 class="course-section-title">Garanta sua vaga agora</h2>
      <p class="course-section-desc">Condição especial por tempo limitado</p>
    </div>
    <div class="course-pricing-card">
      <div class="course-pricing-badge">🔥 70% OFF - Últimas vagas!</div>
      <div class="course-pricing-old">R$ 997,00</div>
      <div class="course-pricing-current">R$ 297</div>
      <div class="course-pricing-installment">ou 12x de R$ 29,70 sem juros</div>
      <div class="course-pricing-features">
        <div class="course-pricing-feature"><span>✓</span> Acesso vitalício ao curso</div>
        <div class="course-pricing-feature"><span>✓</span> +150 aulas em vídeo HD</div>
        <div class="course-pricing-feature"><span>✓</span> 12 projetos práticos</div>
        <div class="course-pricing-feature"><span>✓</span> Certificado de conclusão</div>
        <div class="course-pricing-feature"><span>✓</span> Comunidade exclusiva</div>
        <div class="course-pricing-feature"><span>✓</span> Todos os bônus inclusos</div>
        <div class="course-pricing-feature"><span>✓</span> Suporte prioritário</div>
      </div>
      <a href="#" class="course-pricing-cta">QUERO ME MATRICULAR AGORA</a>
      <div class="course-pricing-secure">🔒 Pagamento 100% seguro</div>
    </div>
  </div>
</section>

<!-- GUARANTEE -->
<section class="course-guarantee">
  <div class="course-guarantee-inner">
    <div class="course-guarantee-icon">🛡️</div>
    <div class="course-guarantee-content">
      <h3>Garantia Incondicional de 30 Dias</h3>
      <p>Se em 30 dias você não estiver 100% satisfeito com o curso, basta enviar um e-mail e devolvemos todo o seu investimento. Sem perguntas, sem burocracia. O risco é todo nosso!</p>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer class="course-footer">
  <p>© 2024 Curso Python Completo. Todos os direitos reservados.</p>
</footer>
`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'coming-soon',
    name: 'Em Breve',
    description: 'Página de coming soon com lista de espera',
    thumbnail: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&h=300&fit=crop',
    category: 'product-launch',
    gjsHtml: `
<!-- COMING SOON -->
<section style="background: linear-gradient(135deg, #0c0a1d 0%, #1a103d 50%, #2d1f5c 100%); min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 40px 20px; position: relative; overflow: hidden;">
  <div style="position: absolute; inset: 0; background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle fill=\"rgba(255,255,255,0.03)\" cx=\"16\" cy=\"16\" r=\"1\"/></svg>') repeat;"></div>
  <div style="max-width: 600px; text-align: center; position: relative; z-index: 1;">
    <div style="width: 80px; height: 80px; background: linear-gradient(135deg, #8b5cf6, #d946ef); border-radius: 20px; display: flex; align-items: center; justify-content: center; margin: 0 auto 40px; font-size: 36px;">🚀</div>
    <span style="display: inline-block; padding: 8px 20px; background: rgba(139, 92, 246, 0.2); border: 1px solid rgba(139, 92, 246, 0.3); border-radius: 50px; color: #c4b5fd; font-size: 14px; font-weight: 500; margin-bottom: 24px;">
      EM DESENVOLVIMENTO
    </span>
    <h1 style="font-size: 4rem; font-weight: 900; color: white; margin-bottom: 24px; line-height: 1.1;">
      Algo incrível está chegando
    </h1>
    <p style="font-size: 1.25rem; color: #a78bfa; margin-bottom: 48px; line-height: 1.7;">
      Estamos trabalhando em algo especial. Seja o primeiro a saber quando lançarmos!
    </p>
    <form style="display: flex; gap: 12px; max-width: 450px; margin: 0 auto 32px;" data-success-message="Voce esta na lista! Avisaremos assim que lancarmos.">
      <input type="email" name="email" placeholder="Seu melhor e-mail" required style="flex: 1; padding: 18px 24px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); border-radius: 12px; color: white; font-size: 1rem; outline: none;"/>
      <button type="submit" style="padding: 18px 32px; background: linear-gradient(135deg, #8b5cf6, #d946ef); color: white; font-weight: 700; border: none; border-radius: 12px; cursor: pointer; white-space: nowrap;">
        Avise-me
      </button>
    </form>
    <p style="color: #7c3aed; font-size: 14px;">
      +2.500 pessoas já estão na lista de espera
    </p>
    <div style="display: flex; justify-content: center; gap: 24px; margin-top: 60px;">
      <a href="#" style="color: #6b7280; text-decoration: none;">Twitter</a>
      <a href="#" style="color: #6b7280; text-decoration: none;">Instagram</a>
      <a href="#" style="color: #6b7280; text-decoration: none;">LinkedIn</a>
    </div>
  </div>
</section>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  },
  {
    id: 'consulting',
    name: 'Consultoria',
    description: 'Serviços de consultoria e assessoria profissional',
    thumbnail: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop',
    category: 'agency',
    gjsHtml: `
<!-- CONSULTING HERO -->
<section style="background: #0f172a; padding: 100px 20px;">
  <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center;">
    <div>
      <h1 style="font-size: 4rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.1;">
        Consultoria estratégica para
        <span style="color: #3b82f6;"> negócios ambiciosos</span>
      </h1>
      <p style="font-size: 1.25rem; color: #94a3b8; margin-bottom: 40px; line-height: 1.7;">
        Ajudamos empresas a desbloquearem seu potencial máximo com estratégias personalizadas e execução impecável.
      </p>
      <div style="display: flex; gap: 16px; flex-wrap: wrap;">
        <a href="#" style="display: inline-block; padding: 18px 36px; background: #3b82f6; color: white; font-weight: 700; border-radius: 8px; text-decoration: none;">
          Agendar Diagnóstico Gratuito
        </a>
        <a href="#" style="display: inline-block; padding: 18px 36px; border: 2px solid #334155; color: #94a3b8; font-weight: 600; border-radius: 8px; text-decoration: none;">
          Ver Cases
        </a>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
      <div style="padding: 32px; background: #1e293b; border-radius: 16px;">
        <div style="font-size: 3rem; font-weight: 900; color: #3b82f6;">150+</div>
        <div style="color: #64748b;">Empresas atendidas</div>
      </div>
      <div style="padding: 32px; background: #1e293b; border-radius: 16px;">
        <div style="font-size: 3rem; font-weight: 900; color: #3b82f6;">R$50M</div>
        <div style="color: #64748b;">Em resultados gerados</div>
      </div>
      <div style="padding: 32px; background: #1e293b; border-radius: 16px;">
        <div style="font-size: 3rem; font-weight: 900; color: #3b82f6;">12</div>
        <div style="color: #64748b;">Anos de experiência</div>
      </div>
      <div style="padding: 32px; background: #1e293b; border-radius: 16px;">
        <div style="font-size: 3rem; font-weight: 900; color: #3b82f6;">97%</div>
        <div style="color: #64748b;">Taxa de satisfação</div>
      </div>
    </div>
  </div>
</section>

<!-- SERVICES -->
<section style="padding: 100px 20px; background: white;">
  <div style="max-width: 1200px; margin: 0 auto;">
    <div style="text-align: center; margin-bottom: 60px;">
      <h2 style="font-size: 3rem; font-weight: 800; color: #0f172a;">Nossas Especialidades</h2>
      <p style="font-size: 1.25rem; color: #64748b; margin-top: 16px;">Soluções completas para transformar seu negócio</p>
    </div>
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); gap: 32px;">
      <div style="padding: 40px; border: 2px solid #e2e8f0; border-radius: 20px;">
        <div style="font-size: 48px; margin-bottom: 20px;">📈</div>
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin-bottom: 12px;">Estratégia de Crescimento</h3>
        <p style="color: #64748b; line-height: 1.7; margin-bottom: 20px;">Desenvolvemos roadmaps estratégicos para escalar sua empresa de forma sustentável.</p>
        <a href="#" style="color: #3b82f6; font-weight: 600; text-decoration: none;">Saiba mais →</a>
      </div>
      <div style="padding: 40px; border: 2px solid #e2e8f0; border-radius: 20px;">
        <div style="font-size: 48px; margin-bottom: 20px;">⚙️</div>
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin-bottom: 12px;">Otimização de Processos</h3>
        <p style="color: #64748b; line-height: 1.7; margin-bottom: 20px;">Identificamos gargalos e implementamos melhorias para aumentar eficiência.</p>
        <a href="#" style="color: #3b82f6; font-weight: 600; text-decoration: none;">Saiba mais →</a>
      </div>
      <div style="padding: 40px; border: 2px solid #e2e8f0; border-radius: 20px;">
        <div style="font-size: 48px; margin-bottom: 20px;">👥</div>
        <h3 style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin-bottom: 12px;">Gestão de Pessoas</h3>
        <p style="color: #64748b; line-height: 1.7; margin-bottom: 20px;">Estruturamos times de alta performance e cultura organizacional forte.</p>
        <a href="#" style="color: #3b82f6; font-weight: 600; text-decoration: none;">Saiba mais →</a>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section style="padding: 100px 20px; background: #3b82f6;">
  <div style="max-width: 800px; margin: 0 auto; text-align: center;">
    <h2 style="font-size: 3rem; font-weight: 800; color: white; margin-bottom: 20px;">Pronto para dar o próximo passo?</h2>
    <p style="font-size: 1.25rem; color: rgba(255,255,255,0.9); margin-bottom: 40px;">Agende uma conversa gratuita de 30 minutos com um de nossos consultores.</p>
    <a href="#" style="display: inline-block; padding: 20px 48px; background: white; color: #3b82f6; font-weight: 800; font-size: 1.1rem; border-radius: 8px; text-decoration: none;">
      Agendar Agora →
    </a>
  </div>
</section>`,
    gjsCss: '',
    gjsComponents: '',
    gjsStyles: ''
  }
];

// Combinar templates originais com os novos
export const allTemplates: PageTemplate[] = [...templates, ...newTemplates];

export const categories = [
  { id: 'all', label: 'Todos' },
  { id: 'saas', label: 'SaaS' },
  { id: 'lead-magnet', label: 'Lead Magnet' },
  { id: 'webinar', label: 'Webinar' },
  { id: 'product-launch', label: 'Lançamento' },
  { id: 'agency', label: 'Agência/Serviços' },
  { id: 'ecommerce', label: 'E-commerce' },
  { id: 'pet', label: 'Pet/Veterinária' }
];
